import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import type { FC, ReactNode } from 'react';
import { isDev } from '@constants/env';

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			refetchOnWindowFocus: false,
		},
	},
});

type Props = {
	children: ReactNode;
};

const PageProviders: FC<Props> = ({ children }) => (
	<QueryClientProvider client={queryClient}>
		{children}
		{isDev && <ReactQueryDevtools initialIsOpen={false} />}
	</QueryClientProvider>
);

export default PageProviders;
